import { render, staticRenderFns } from "./Bamako.vue?vue&type=template&id=30f01ca1&"
import script from "./Bamako.vue?vue&type=script&lang=js&"
export * from "./Bamako.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports